import React, { useState, useEffect } from 'react';
import ApiCaller from "../../../../api/apiCaller";

const SearchBox = ({ onItemClick }) => {

    const [searchKeywords, setSearchKeywords] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showSearchResult, setShowSearchResult] = useState(false);

    const debouncedSearchKeywords = useDebounce(searchKeywords, 500);

    const searchBoxHandler = (text) => {
        if (text === '' || !setSearchKeywords) {
            // If no search keyword is entered
            // Clear the UI
            setSearchKeywords('');
            setSearchResults([]);
            setShowSearchResult(false);
        } else {
            setSearchKeywords(text);
        }
    }

    const getSearchResult = async () => {
        const uri = `locationsearch/?q=${debouncedSearchKeywords}`;
        const res = await ApiCaller.get(uri);
        if (res.status === 'ok') {
            setSearchResults(res.results?.predictions || []);
            setShowSearchResult(true);
        }
    }

    const getPlaceDetail = async (placeId) => {
        const uri = `locationsearch/place_detail?place_id=${placeId}`;
        const res = await ApiCaller.get(uri);
        if (res.status === 'ok') {
            return res.results.result;
        } else {
            return null;
        }
    }

    const onSearchResultClick = async (item) => {
        if (onItemClick)  {
            const placeDetail = await getPlaceDetail(item.place_id);
            onItemClick(placeDetail);
            setShowSearchResult(false);
        }
    }

    const onTextBoxFocus = () => {
        setShowSearchResult(true);
    }
    const onTextBoxBlur = () => {
        setShowSearchResult(false);
    }

    useEffect(() => {
        if (searchKeywords) {
            getSearchResult();
        }
    }, [debouncedSearchKeywords]);

    return (
        <div>
            <input
                type="text"
                placeholder="Nhập tên đường, địa điểm để tìm kiếm..."
                style={styles.searchBox}
                onChange={(e) => searchBoxHandler(e.target.value)}
                onFocus={onTextBoxFocus}
            />
            {searchResults && searchResults.length > 0 && showSearchResult &&
                <div style={styles.resultWrapper}>
                    {searchResults.map((searchResult, index) =>
                        <div
                            key={`result-${index}`}
                            style={styles.searchResult}
                            onClick={() => onSearchResultClick(searchResult)}
                        >
                            <span style={styles.searchResultName}>{searchResult.description}</span><br />
                        </div>    
                    )}
                </div>
            }
        </div>
    );
}

const styles = {
    searchBox: {
        backgroundColor: 'white',
        minHeight: 36,
        minWidth: 320,
        boxShadow: '0 2px 4px 0 rgba(0,0,0,.24)',
        paddingTop: 6,
        paddingRight: 12,
        paddingLeft: 12,
        paddingBottom: 6,
        borderRadius: 4,
        border: 0,
    },
    resultWrapper: {
        width: 360,
        backgroundColor: 'white',
        padding: 12,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        boxShadow: '0 2px 4px 0 rgba(0,0,0,.24)',
    },
    searchResult: {
        paddingBottom: 10,
        paddingTop: 10,
        fontSize: 14,
        borderBottom: '1px solid var(--color-line)',
    },
    searchResultName: {
        fontSize: 14,
    },
    searchResultAddress: {
        color: 'var(--color-muted)',
        fontSize: 12,
    },
}

// Hook
const useDebounce = (value, delay) => {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);
  
    useEffect(
      () => {
        // Update debounced value after delay
        const handler = setTimeout(() => {
          setDebouncedValue(value);
        }, delay);
  
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return () => {
          clearTimeout(handler);
        };
      },
      [value, delay] // Only re-call effect if value or delay changes
    );
  
    return debouncedValue;
}

export default SearchBox;

